import { Button } from '../components/button'
import type { ParamsType, SetParamsType } from './types'

type PaginationProps = {
	total: number
	params: ParamsType
	setParams: SetParamsType
}

export function Pagination({ params, setParams, total }: PaginationProps) {
	if (params.page <= 1 && !total) return null

	const currentPage = params.page
	const pages = []
	const startPage = Math.max(1, currentPage - 2)
	const totalPages = Math.ceil(total / 20)
	const endPage = Math.min(currentPage + 2, totalPages)

	for (let i = startPage; i <= endPage; i++) {
		pages.push(i)
	}

	if (totalPages === 1) return null

	return (
		<div className="my-4 flex items-center justify-center gap-2">
			{!pages.includes(1) ? (
				<>
					<Button
						key="1"
						onPress={() => setParams({ page: 1 })}
						variant="SECONDARY"
						size="SMALL"
					>
						1
					</Button>{' '}
					{pages.includes(2) ? null : <span>◦</span>}
				</>
			) : null}
			{pages.map(page => (
				<Button
					key={page}
					isDisabled={page === currentPage}
					onPress={() => setParams({ page })}
					variant={page === currentPage ? 'PRIMARY' : 'SECONDARY'}
					size="SMALL"
				>
					{page}
				</Button>
			))}
			{!pages.includes(totalPages) ? (
				<>
					{pages.includes(totalPages - 1) ? null : <span>◦</span>}
					<Button
						key={totalPages}
						onPress={() => setParams({ page: totalPages })}
						variant="SECONDARY"
						size="SMALL"
					>
						{totalPages}
					</Button>
				</>
			) : null}
		</div>
	)
}
